module.exports = __webpack_public_path__ + "43b9c9baeeb169567dd2aa42ea4a46ea.jpg";